import { jsx as _jsx } from "react/jsx-runtime";
import { EventNames, TrackingEventTypes, useAnalytics } from "@cinch-nx/shared-analytics";
import { capitaliseFirstLetter } from "../../utils/capitalise-first-letter";
import { Primary } from "@cinch-labs/design-system";
export var StoreCtaButton = function(param) {
    var slug = param.slug, trackEventTitle = param.trackEventTitle;
    var StoreName = "Search all cars at ".concat(capitaliseFirstLetter(slug));
    var trackEvent = useAnalytics().trackEvent;
    var storeBySlugPath = "/used-cars?store=".concat(slug);
    var handleClick = function() {
        trackEvent({
            eventName: trackEventTitle,
            type: TrackingEventTypes.ADOBE,
            data: {
                action: "select",
                event: {
                    name: EventNames.click,
                    type: capitaliseFirstLetter(slug),
                    category: trackEventTitle,
                    label: "search all cars"
                }
            }
        });
        window.open(storeBySlugPath, "_blank");
    };
    return /*#__PURE__*/ _jsx(Primary, {
        type: "submit",
        "data-testid": "store-button",
        onClick: handleClick,
        children: StoreName
    });
};
